<style lang="scss" scoped>
.mis-class {
	padding: 15px;
	&__right {
		float: right;
		font-size: 12px;
		padding: 3px;
	}
	&__class_detail {
		float: left;
		font-size: 12px;
		width: 79%;
	}
	&__item-detail {
		width: 20px;
	}
	&__values {
		font-weight: 600;
	}
	&__button {
		margin-top: 10px;
		padding: 5px;
	}
	&__tag {
		font-size: 8px !important;
		margin: 2px;
	}
}
.clearfix:before,
.clearfix:after {
	display: table;
	content: "";
}
.clearfix:after {
	clear: both
}
</style>
<template lang="pug">
div.mis-class(:style="background")
	div.clearfix
		div.mis-class__class_detail
			el-row
				el-col(:span="8") MIS ID: 
				el-col.mis-class__values(:span="16") {{ misClass.id.split("-")[0] }}
			el-row
				el-col(:span="8") Type: 
				el-col.mis-class__values(:span="16") {{ misClass.type.toUpperCase() }}
			el-row
				el-col(:span="8") MIS Name: 
				el-col.mis-class__values(:span="16") {{ misClass.name }}
			el-row(v-if="allowCreation")
				el-col(:span="8") Teams:
				el-col.mis-class__values(:span="16")
					el-tag.mis-class__tag(v-if="classrooms && classrooms.length" v-for="(classroom, index) in classrooms" size="mini", type="info") {{ classroom.name }}
					template(v-if="!classrooms.length") None
		el-button.mis-class__right(type="primary", @click="createClass", v-if="allowCreation") Create	
		el-button.mis-class__right(v-if="allowRemoval" size="mini", icon="el-icon-remove-outline", type="danger", @click="removeMisClass")
		
</template>

<script>
import gql from "graphql-tag";

export default {
	props: {
        id: String,
		misClasses: Array,
		allowRemoval: Boolean,
		allowCreation: Boolean,
		matchesInput: Array,
		providerClass: Object,
		persistedMatches: Array,
	},
	components: {
	},
	data() {
		return {
		};
	},
	computed: {
		misClass() {
			return !_.isEmpty(this.misClasses) ? this.misClasses.find(item => item.id === this.id) : [];
		},
		status() {
			if (!this.providerClass) return null;

			let match = _.find(this.matchesInput, { wondeId: this.id.split("-")[0], wondeIdType: this.misClass.type, providerId: this.providerClass.id });

			if (match) {
				return match.courseState === "ACTIVE" ? "NEW" : match.courseState;
			} else {
				match = _.filter(this.matchesInput, (input) => {
					const misClasses = _.isEmpty(input.misClasses) ? [] : _.map(input.misClasses, (cls) => cls.id);
					
					return misClasses.includes(this.id);
				})

				return match.length ? _.first(match).courseState : null;
			}
		},
		classrooms() {
			let matchedClassrooms = [];

			if (!this.persistedMatches) return [];

			for (let cls of this.persistedMatches) {
				if (cls.misClasses && cls.misClasses.includes(this.id)) {
					matchedClassrooms.push(cls);
				}
			}

			return matchedClassrooms;
		},
		background() {
			if (this.status === "NEW") {
				return  { background: '#fdf6ec', borderColor: '#faecd8' };
			}
			return {}
		}
	},
	methods: {
		removeMisClass() {
			this.$emit('remove-class', this.id);
		},
		createClass() {
			this.$emit('create-class', this.id);
		}
	},
	apollo: {
		// classes: {
		// 	query: gql`
		// 		{
		// 			Classes {
		// 				id
		// 				name
		// 				type
		// 			}
		// 		}
		// 	`,
		// 	fetchPolicy: "cache-and-network",
		// 	update: r =>
		// 		_(r.Classes)
		// 			.map(cls => ({
		// 				...cls,
		// 				assigned: null
		// 			}))
		// 			.sortBy("name")
		// 			.value()
		// },
	}
};
</script>